/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tangy_Mad_Shark_AimInputs */

const fr_tangy_mad_shark_aim = /** @type {(inputs: Tangy_Mad_Shark_AimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editer le programme`)
};

/**

* @param {Tangy_Mad_Shark_AimInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tangy_mad_shark_aim = /** @type {((inputs?: Tangy_Mad_Shark_AimInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tangy_Mad_Shark_AimInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tangy_mad_shark_aim(inputs)
});